import React from "react";
import EditListModal from "./modal/edit";
import useToggle from "hooks/useToggle";
import { ReactComponent as Pencil } from "assets/svgs/fi-rs-pencil.svg";
import clsx from "clsx/lite";

const WishlistItem = ({ list, handleListClick }) => {
	const [editListModalOpen, toggleEditListModal] = useToggle();
	const listLength = list.listcontents.length;

	return (
		<>
			{editListModalOpen && <EditListModal list={list} isOpen={editListModalOpen} toggle={toggleEditListModal} />}
			<div className="p-3 flex flex-col w-[calc(50%-10px)] sm:w-56 gap-2 bg-cream">
				<div className="flex justify-between">
					<div className="flex flex-col">
						<p>{list.lname}</p>
						<p className="text-xs text-secondary">{list.listcontents.length} products</p>
					</div>
					<button onClick={toggleEditListModal} className="flex">
						<Pencil className="mt-2" />
					</button>
				</div>
				<div className={
					clsx("flex gap-2 w-full aspect-square overflow-hidden",
						listLength === 2 ? "flex-col" : "flex-wrap")}>
					{list.listcontents.length > 0 ?
						list.listcontents?.slice(0, 4).map((item, index) => (
							<div key={index} className={clsx(
								listLength > 2 ? "w-[calc(50%-4px)]" : "w-full",
								listLength > 1 && "h-auto md:h-24",
								"flex-auto object-contain overflow-hidden")}>
								<img src={item?.iu} alt={item?.dt} loading="lazy" />
							</div>
						))
						: <p className="m-auto">This is an empty list!</p>
					}
				</div>
				<div className="w-full flex justify-center">
					<button onClick={() => handleListClick(list.lid)}
						className="btn-primary w-full text-xs md:text-sm py-2 px-4 sm:py-4 sm:px-12">
						View List
					</button>
				</div>
			</div>
		</>
	);
};

export default WishlistItem;
